import StoriesList from "./StoriesList";

export default StoriesList;
